import { UserWatchedQuotePostRequestBody } from '@lio/api-types';
import { useQueryClient, useMutation } from '@tanstack/react-query';
import { useClient } from '@utils/api-client';

export const useCreateWatchedQuote = () => {
  const queryClient = useQueryClient();
  const client = useClient();
  const mutationFn = ({ quoteId, userId }: UserWatchedQuotePostRequestBody) => {
    const url = `user/${userId}/watched-quote`;
    return client.post(url, {
      json: {
        quoteId,
      },
    });
  };
  const queryKey = ['quotes'];
  const result = useMutation({
    mutationFn,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey });
    },
    onError: () => {
      queryClient.invalidateQueries({ queryKey });
    },
  });
  return { ...result, createWatchedQuote: result.mutate };
};
